<template functional>
    <div class="dropdown">
        <div class="dropdown-content dropdown-content-padded">
            There was an error while processing this filter. You may only view the summary.
        </div>
    </div>
</template>

<script>
    export default {
        name: 'blank-filter',
    };
</script>
